var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dadosCadastros
    ? _c(
        "validation-observer",
        { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
        [
          _vm.hasAnaliseAutomatizada
            ? _c(
                "div",
                [
                  _c(
                    "analise-automatizada",
                    {
                      attrs: {
                        protocoloProcesso: _vm.processo.numeroProtocolo,
                        analiseSalva:
                          _vm.dadosCadastros.despacho.analiseAutomatizada,
                        idDespacho: _vm.dadosCadastros.despacho.id,
                        radios: _vm.acoesRadio,
                        isDecisao: _vm.isDecisao,
                        active: _vm.active,
                        tipoProcesso: _vm.processo.tipo.codigo
                      },
                      on: {
                        cancelar: _vm.cancelar,
                        changeAnalise: _vm.changeAnalise,
                        retornarCaixa: _vm.retornarCaixa,
                        finalizar: _vm.finalizarAutomatizada,
                        salvar: _vm.salvarAutomatizada,
                        changeRadio: _vm.changeRadio,
                        setActive: _vm.setActivePai
                      }
                    },
                    [
                      _c("template", { slot: "anexoMapas" }, [
                        _vm.processo.status === "EM_ANALISE" ||
                        _vm.processo.status === "EM_REVISAO"
                          ? _c(
                              "div",
                              [
                                _c("app-label", {
                                  staticClass: "campo",
                                  attrs: {
                                    label: "Mapas",
                                    required: _vm.isValidate !== ""
                                  }
                                }),
                                _c("validation-provider", {
                                  attrs: { rules: _vm.isValidate },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("app-anexo", {
                                              attrs: {
                                                id:
                                                  "upload-anexo-mapa-gcg-automatizada",
                                                tiposArquivosPermitidos:
                                                  ".png, .jpg, .jpeg, .pdf, .doc, .docx",
                                                files: _vm.mapas,
                                                showAnexar: true,
                                                errors: errors
                                              },
                                              on: {
                                                uploadFile: _vm.uploadMapa,
                                                removeFile: _vm.removeMapa,
                                                downloadDocumentoCadastro:
                                                  _vm.getDownload
                                              },
                                              model: {
                                                value: _vm.mapas,
                                                callback: function($$v) {
                                                  _vm.mapas = $$v
                                                },
                                                expression: "mapas"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1108093094
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.showModalBeneficiarios
                    ? _c("app-modal-beneficiario", {
                        attrs: {
                          protocoloProcesso: _vm.processo.numeroProtocolo,
                          beneficiarios:
                            _vm.dadosCadastro.dadosCadastro.dados.cadastro
                              .beneficiarios,
                          cadastroOriginal:
                            _vm.dadosCadastro.dadosCadastro.dados.cadastro
                        },
                        on: {
                          closeModal: function($event) {
                            _vm.showModalBeneficiarios = false
                          },
                          updateBeneficiarios: _vm.updateBeneficiarios
                        }
                      })
                    : _vm._e(),
                  _vm.showModalDespacho
                    ? _c("app-modal-selecionar-modelo-notificacao", {
                        attrs: {
                          tiposModelo: _vm.tiposModelo,
                          titulo: _vm.tituloModalModelo,
                          idProcesso: _vm.processo.id,
                          showModal: _vm.showModalDespacho
                        },
                        on: {
                          closeModal: _vm.fecharModalDespacho,
                          setTextoDespacho: _vm.setTextoDespacho
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-card",
                    {
                      staticClass: "card-collapse",
                      attrs: { shadow: "hover" }
                    },
                    [
                      _c("app-header-dados-processo", {
                        attrs: {
                          processo: _vm.processo,
                          isCCR: _vm.isCCR,
                          dadosCadastros: _vm.dadosCadastros,
                          numeroTituloDominial: _vm.numeroTituloDominial,
                          numeroProcessoFisico: _vm.numeroProcessoFisico,
                          dataEmissaoTituloDominial:
                            _vm.dataEmissaoTituloDominial
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-despachos", {
                            attrs: {
                              idProcesso: _vm.idProcesso,
                              data: _vm.dadosCadastros.setores,
                              tituloMinuta:
                                _vm.dadosCadastros.despacho.processo.tipo
                                  .codigo === "CERTIDAO_TITULO"
                                  ? "Minuta da certidão"
                                  : "Minuta do título"
                            },
                            on: {
                              getDownload: _vm.getDownload,
                              getAnotacao: _vm.getAnotacao
                            }
                          })
                        ],
                        1
                      ),
                      _vm.dadosVtn
                        ? _c(
                            "el-card",
                            { attrs: { shadow: "hover" } },
                            [
                              _c(
                                "el-collapse",
                                [
                                  _c(
                                    "el-collapse-item",
                                    { attrs: { title: "Dados do VTN" } },
                                    [
                                      _c(
                                        "el-card",
                                        { attrs: { shadow: "hover" } },
                                        [
                                          _vm.dadosVtn
                                            ? _c("visualizar-vtn", {
                                                attrs: {
                                                  vtn: _vm.dadosVtn,
                                                  processo: _vm.processo,
                                                  exibeObs: false,
                                                  escolheuExterno:
                                                    _vm.dadosVtn.status !==
                                                    "Criado"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isArquivamentoIndeferimento &&
                      _vm.responseAnalise.inserirDocumentoDeArquivamento &&
                      this.isMa &&
                      !this.isReurbIndividual
                        ? _c(
                            "el-card",
                            [
                              _c("app-label", {
                                attrs: {
                                  label:
                                    "Inclua a Carta de Notificação ao Interessado",
                                  required: _vm.isValidateCarta !== ""
                                }
                              }),
                              _c("validation-provider", {
                                attrs: { rules: _vm.isValidateCarta },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-anexo", {
                                            attrs: {
                                              id: "upload-carta-notificacao",
                                              files: _vm.cartas,
                                              showAnexar: true,
                                              errors: errors,
                                              tiposArquivosPermitidos:
                                                _vm.tiposArquivosPermitidosMapas,
                                              showUpload:
                                                _vm.cartas.length === 0
                                            },
                                            on: {
                                              uploadFile:
                                                _vm.uploadCartaNotificacao,
                                              removeFile:
                                                _vm.removeCartaNotificacao,
                                              downloadDocumentoCadastro:
                                                _vm.getDownload
                                            },
                                            model: {
                                              value: _vm.cartas,
                                              callback: function($$v) {
                                                _vm.cartas = $$v
                                              },
                                              expression: "cartas"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  87136372
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.documentosValidar &&
                      !_vm.isPublicacaoDoe &&
                      !_vm.isRetornarOuArquivar &&
                      _vm.processo.setor === "GCQ" &&
                      _vm.dadosCadastro.dadosCadastro &&
                      _vm.dadosCadastro.dadosCadastro.dados.cadastro
                        .beneficiarios.length
                        ? _c(
                            "el-card",
                            {
                              staticClass: "card-collapse",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "margin-bottom",
                                  attrs: {
                                    data: [
                                      {
                                        qtde:
                                          _vm.dadosCadastro.dadosCadastro.dados
                                            .cadastro.beneficiarios.length
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Quantidade de beneficiários",
                                      prop: "qtde"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { width: 250 },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "flex-end" },
                                                [
                                                  _c("app-action-button", {
                                                    attrs: {
                                                      innerText:
                                                        "Visualizar beneficiários",
                                                      icone: "eye",
                                                      text:
                                                        "Visualizar beneficiários",
                                                      fontSize: "18"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showModalBeneficiarios = true
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      109024550
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.documentosValidar &&
                        !_vm.isPublicacaoDoe &&
                        !_vm.isRetornarOuArquivar &&
                        _vm.showValidacaoDocumentos) ||
                      (this.isMa &&
                        _vm.dadosCadastro &&
                        !_vm.isRetornarOuArquivar &&
                        _vm.documentosValidar)
                        ? _c("app-dados-cadastro", {
                            attrs: {
                              dadosCadastros: !this.isMa
                                ? _vm.dadosCadastros.dadosCadastros
                                : _vm.documentosFiltrados()
                            },
                            on: {
                              setValidacaoDocumentos:
                                _vm.setValidacaoDocumentos,
                              downloadDocumentoCadastro:
                                _vm.downloadDocumentoCadastro,
                              setDocumentosValidar: _vm.setDocumentosValidar
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  (_vm.isPublicacaoDoe || _vm.isPublicacaoNutit) &&
                  !_vm.isRetornarOuArquivar &&
                  _vm.processo.setor !== "GCQ"
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-publicacao", {
                            attrs: {
                              anexoPublicacao: _vm.anexoPublicacao
                                ? [_vm.anexoPublicacao]
                                : [],
                              numeroDoe: _vm.numeroDoe,
                              dataPublicacao: _vm.dataPublicacao,
                              blockFutureDate: true
                            },
                            on: {
                              setAnexoPublicacao: _vm.setAnexoPublicacao,
                              setPublicacaoNumero: _vm.setPublicacaoNumero,
                              setPublicacaoData: _vm.setPublicacaoData,
                              removeAnexoPublicacao: _vm.removeAnexoPublicacao,
                              downloadDocumentoCadastro:
                                _vm.downloadDocumentoCadastro
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.regras.showArquivosBloqueio ||
                  _vm.regras.showArquivosMonitoramento
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c(
                            "el-collapse",
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { title: "Resposta do Interessado" } },
                                [
                                  _c("app-visualizar-conversa", {
                                    attrs: {
                                      conversa:
                                        _vm.responseAnalise.dadosMonitoramento
                                          .defesa
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.regras.showArquivosBloqueio ||
                  _vm.regras.showArquivosMonitoramento
                    ? _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c("app-visualizar-monitoramento-area-tab", {
                            attrs: {
                              idProcesso: _vm.processo.id,
                              numeroProcesso: _vm.processo.numeroProcesso
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.regras.showMapa || _vm.isGeoMenssura) &&
                  !_vm.isRetornarOuArquivar
                    ? _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Mapas",
                              required: _vm.isValidate !== ""
                            }
                          }),
                          _c("validation-provider", {
                            attrs: { rules: _vm.isValidate !== "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-anexo", {
                                        attrs: {
                                          id: "upload-mapas",
                                          files: _vm.mapas,
                                          showAnexar: true,
                                          errors: errors,
                                          tiposArquivosPermitidos:
                                            _vm.tiposArquivosPermitidosMapas,
                                          showUpload: _vm.isReurb
                                            ? _vm.mapas.length === 0
                                            : true
                                        },
                                        on: {
                                          uploadFile: _vm.uploadMapa,
                                          removeFile: _vm.removeMapa,
                                          downloadDocumentoCadastro:
                                            _vm.getDownload
                                        },
                                        model: {
                                          value: _vm.mapas,
                                          callback: function($$v) {
                                            _vm.mapas = $$v
                                          },
                                          expression: "mapas"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2321262925
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dadosCadastros.isEmissaoCustas &&
                  !_vm.isRetornarOuArquivar
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-geracao-custas", {
                            attrs: {
                              custa: _vm.dadosCadastros.despacho.custa,
                              exibirLabelCustas: true,
                              exibirNumeroModulos: false,
                              exibirFatorLocalizacao: true,
                              exibirElaboracaoPublicacao: false,
                              exibirDataVencimento: false,
                              processo: _vm.processo
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.dadosCadastros.isEmissaoDaeExterno &&
                    !_vm.isRetornarOuArquivar) ||
                  _vm.isRevisaoDadosCusta
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-emitir-dae-externo", {
                            attrs: {
                              dadosBoletoDespacho:
                                _vm.dadosCadastros.despacho.dadosBoletoDespacho
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dadosCadastros.despacho &&
                  _vm.hasAnexoDocumento &&
                  !_vm.isRetornarOuArquivar
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-documentos", {
                            attrs: {
                              isAnalise: true,
                              idUploadDocumento:
                                _vm.componenteAnexoDocumento.idUploadDocumento,
                              titulo: _vm.componenteAnexoDocumento.titulo,
                              maxSize: 5000,
                              "valid-extensions": [
                                "png",
                                "jpg",
                                "jpeg",
                                "pdf",
                                "doc",
                                "docx"
                              ],
                              documentos:
                                _vm.componenteAnexoDocumento.documentos,
                              tiposDocumentos:
                                _vm.componenteAnexoDocumento.tiposDocumentos,
                              tiposDocumentosObrigatorios:
                                _vm.componenteAnexoDocumento
                                  .tiposDocumentosObrigatorios,
                              pecasTecnicas: true,
                              removeOutros: true,
                              aba: _vm.componenteAnexoDocumento.aba,
                              observer: this.$refs.validation,
                              isValidacaoPeloMenosUmDocumento: this.isMa
                                ? false
                                : _vm.isValidacaoPeloMenosUmDocumento
                            },
                            on: { removedDoc: _vm.removeFile }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dadosCadastros.despacho &&
                  _vm.isRatificacaoPoligono &&
                  !_vm.isRetornarOuArquivar &&
                  _vm.processo.tipo.codigo !==
                    "CANCELAMENTO_CLAUSULA_RESOLUTIVA"
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: _vm.isRequiredRatificacaoPoligono,
                                  name: "Georreferenciamento/Geometria"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("mapa-analise-geomensor", {
                                            attrs: {
                                              localizacoes:
                                                _vm.dadosCadastros.despacho
                                                  .localizacoes,
                                              name: "Geometria",
                                              idMapa:
                                                "mapaAnaliseRatificacaoPoligono",
                                              errors: errors
                                            },
                                            model: {
                                              value:
                                                _vm.dadosCadastros.despacho
                                                  .localizacoes,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosCadastros.despacho,
                                                  "localizacoes",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dadosCadastros.despacho.localizacoes"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  306259923
                                )
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  this.showSecaoDadosImovel
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-formulario-analise-dados-imovel", {
                            attrs: {
                              municipios: this.municipios,
                              dadosImovel: _vm.dadosImovelComponente,
                              isReurbIndividual: this.isReurbIndividual,
                              isOnerosoNaoOneroso: this.isOnerosoNaoOneroso,
                              isMa: this.isMa
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dadosCadastros.pecasTecnicas.length > 0 &&
                  !_vm.isRetornarOuArquivar
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("p", { staticClass: "label" }, [
                            _vm._v("Peças Técnicas do cadastro")
                          ]),
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.dadosCadastros.pecasTecnicas,
                                "show-header": false
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "tipo.descricao" }
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "nome" }
                              }),
                              _c("el-table-column", {
                                attrs: { align: "right", width: "110" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: "Baixar arquivo",
                                                placement: "left"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getDownload({
                                                        id: scope.row.id,
                                                        nome: scope.row.nome,
                                                        caminho:
                                                          scope.row.caminho
                                                      })
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "download",
                                                      size: "lg"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2576469808
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showGeorreferenciamento
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-documentos", {
                            attrs: {
                              isAnalise: true,
                              idUploadDocumento: "documentoGeorreferenciamento",
                              titulo: "Georreferenciamento",
                              maxSize: 5000,
                              "valid-extensions": _vm.extensoes,
                              documentos: _vm.anexosGeorreferenciamento,
                              tiposDocumentos: _vm.tipoDocumentosGeo,
                              tiposDocumentosObrigatorios:
                                _vm.getDocumentosGeo.obrigatorios,
                              pecasTecnicas: true,
                              removeOutros: true,
                              aba: "Portaria",
                              observer: this.$refs.validation
                            },
                            on: {
                              mudaTipo: _vm.mudaTipo,
                              removedDoc: _vm.removeFile
                            }
                          }),
                          !_vm.isRetornarOuArquivar
                            ? _c(
                                "div",
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules:
                                        _vm.isValidate || _vm.isValidateGeo,
                                      name: "Georreferenciamento/Geometria"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("mapa-analise-geomensor", {
                                                attrs: {
                                                  localizacoes:
                                                    _vm.dadosCadastros.despacho
                                                      .localizacoes,
                                                  name: "Geometria",
                                                  idMapa:
                                                    "mapaAnaliseGeomensor",
                                                  errors: errors
                                                },
                                                on: {
                                                  dataEmitted:
                                                    _vm.receiveDataFromChild
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosCadastros.despacho
                                                      .localizacoes,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosCadastros
                                                        .despacho,
                                                      "localizacoes",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosCadastros.despacho.localizacoes"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3281790359
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.uploadDoTermoOuContrato &&
                  !_vm.isRetornarOuArquivar &&
                  !_vm.isDecisao &&
                  !_vm.isAguardandoEntregaCertidao &&
                  !_vm.djAnaliseConjunta
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "radios-despacho-parecer" },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "container-buttons"
                                            },
                                            [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  attrs: { name: "parecer" },
                                                  model: {
                                                    value: _vm.isDecisao,
                                                    callback: function($$v) {
                                                      _vm.isDecisao = $$v
                                                    },
                                                    expression: "isDecisao"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "padding input",
                                                      class: {
                                                        erro: errors.length
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: false,
                                                            border: true
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.decisao
                                                                .primeiro
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: true,
                                                            border: true
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getValueDecisao
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1090408536
                                )
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.uploadDoTermoOuContrato &&
                  !_vm.isRetornarOuArquivar &&
                  !_vm.isDecisao
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.isEstadoAP
                                  ? "Upload da Declaração de entrega de título"
                                  : _vm.uploadDoTermoOuContrato
                                  ? "Upload do termo de recebimento ou contrato"
                                  : "Upload do termo de recebimento"
                              )
                            ),
                            !_vm.isSelectedRetornarEmissaoReurb
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("  *  ")
                                ])
                              : _vm._e()
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              rules: !_vm.isSelectedRetornarEmissaoReurb
                                ? _vm.isValidateTermoRecebimento
                                : ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-anexo", {
                                        attrs: {
                                          id: "upload-termo",
                                          files: _vm.buscarDocumentoTermo(
                                            _vm.termoRecebimento
                                          ),
                                          showAnexar: true,
                                          errors: !_vm.isSelectedRetornarEmissaoReurb
                                            ? errors
                                            : []
                                        },
                                        on: {
                                          uploadFile:
                                            _vm.uploadTermoRecebimento,
                                          removeFile:
                                            _vm.removeTermoRecebimento,
                                          downloadDocumentoCadastro:
                                            _vm.getDownload
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1011564087
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dadosCadastros.despacho.processo.tipo.codigo ===
                    "CERTIDAO_TITULO" &&
                  _vm.processo.status === "AGUARDANDO_PUBLICACAO"
                    ? _c(
                        "el-card",
                        [
                          _c("p", { staticClass: "label" }, [
                            _vm._v("Upload do termo de retificação"),
                            _c("span", { staticClass: "required" }, [
                              _vm._v("  *  ")
                            ])
                          ]),
                          _c("app-anexo", {
                            attrs: {
                              id: "upload-termo-retificacao",
                              files: _vm.termoRetificacao,
                              showAnexar: true
                            },
                            on: {
                              uploadFile: _vm.uploadTermoRetificacao,
                              removeFile: _vm.removeTermoRetificacao,
                              downloadDocumentoCadastro: _vm.getDownload
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAguardandoEdital &&
                  !_vm.isRetornarOuArquivar &&
                  !_vm.isDecisao
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Edital",
                              required: _vm.isValidateEdital !== ""
                            }
                          }),
                          _c("validation-provider", {
                            attrs: { rules: _vm.isValidateEdital },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-anexo", {
                                        attrs: {
                                          id: "upload-edital",
                                          files: _vm.anexosPublicacaoEdital,
                                          showAnexar: true,
                                          errors: errors
                                        },
                                        on: {
                                          uploadFile: _vm.uploadEdital,
                                          removeFile: _vm.removeEdital,
                                          downloadDocumentoCadastro:
                                            _vm.getDownload
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              663261896
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEstadoAP &&
                  _vm.isAnaliseDeTituloDirot &&
                  this.bytes != null
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("p", { staticClass: "label" }, [_vm._v("Título")]),
                          _c("app-pdf-viewer-old", {
                            attrs: { bytes: _vm.bytes }
                          }),
                          _c(
                            "div",
                            { staticClass: "download-button" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "default" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadPdf()
                                    }
                                  }
                                },
                                [
                                  _vm._v("Download PDF  "),
                                  _c("i", { staticClass: "fa fa-download" })
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dadosCadastros
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-collapse",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _vm.showDespachoAndAnexo()
                            ? _c(
                                "div",
                                [
                                  (_vm.regras.showButtonsDecisao &&
                                    !_vm.isArquivamento &&
                                    !_vm.djAnaliseConjunta) ||
                                  (_vm.isReurb && _vm.isDiretorJuridico)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "radios-despacho-parecer"
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: { rules: "required" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "container-buttons"
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio-group",
                                                            {
                                                              attrs: {
                                                                name: "parecer"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.isDecisao,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.isDecisao = $$v
                                                                },
                                                                expression:
                                                                  "isDecisao"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "padding input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-radio",
                                                                    {
                                                                      attrs: {
                                                                        label: false,
                                                                        border: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .decisao
                                                                            .primeiro
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "el-radio",
                                                                    {
                                                                      attrs: {
                                                                        label: true,
                                                                        border: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getValueDecisao
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "help erro"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1090408536
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex-despacho"
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    { staticClass: "label" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatterTipoDespacho
                                                        )
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required"
                                                        },
                                                        [_vm._v("  *  ")]
                                                      ),
                                                      _vm.dadosCadastros
                                                        .despacho.tipo ===
                                                        "ENTREGA_TITULO" &&
                                                      !_vm.isDecisao &&
                                                      !_vm.isEstadoAP
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "light",
                                                                content:
                                                                  "Informe o local onde o título será armazenado",
                                                                placement:
                                                                  "right"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon:
                                                                      "info-circle"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm.regras.showModelo
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.openModalDespacho
                                                          }
                                                        },
                                                        [
                                                          _vm._v("Modelo  "),
                                                          _c("div", {
                                                            staticClass:
                                                              "fa fa-file"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c("app-editor-texto", {
                                                ref: "editorTexto",
                                                staticClass: "input",
                                                class: { erro: errors.length },
                                                on: {
                                                  onTextChange: _vm.onTextChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosCadastros.despacho
                                                      .textoDespacho,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosCadastros
                                                        .despacho,
                                                      "textoDespacho",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosCadastros.despacho.textoDespacho"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3006176769
                                    )
                                  }),
                                  _vm.anexos &&
                                  _vm.dadosCadastros.despacho &&
                                  _vm.dadosCadastros.despacho.documentos
                                    .length === 0
                                    ? _c("app-anexo", {
                                        attrs: {
                                          id: "upload-anexo-despacho",
                                          files: _vm.anexos,
                                          tipoExibir: "ANEXO_ANALISE"
                                        },
                                        on: {
                                          uploadFile: _vm.uploadFile,
                                          removeFile: _vm.removeFile,
                                          downloadDocumentoCadastro:
                                            _vm.downloadDocumentoCadastro
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showButtonsTramitacao
                            ? _c("app-radios-tramitacao", {
                                attrs: {
                                  radios: _vm.acoesRadio,
                                  isDecisao: _vm.isDecisao,
                                  processo: _vm.processo,
                                  isEsconderEncaminhamento:
                                    _vm.dadosCadastros.encaminhamento,
                                  radioInicial: _vm.dadosCadastros.despacho.acao
                                },
                                on: { changeRadio: _vm.changeRadio }
                              })
                            : _vm._e(),
                          _vm.showRadioRealizarGeorreferenciamento
                            ? _c(
                                "el-row",
                                {
                                  staticClass: "top-georreferenciamento",
                                  attrs: { gutter: 20 }
                                },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "É necessário realizar o georreferenciamento ?"
                                        )
                                      ]),
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        name: "parecer"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.isRealizarGeorreferenciamento,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.isRealizarGeorreferenciamento = $$v
                                                        },
                                                        expression:
                                                          "isRealizarGeorreferenciamento"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "padding input"
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio",
                                                            {
                                                              attrs: {
                                                                label: true,
                                                                border: true
                                                              }
                                                            },
                                                            [_vm._v("Sim")]
                                                          ),
                                                          _c(
                                                            "el-radio",
                                                            {
                                                              attrs: {
                                                                label: false,
                                                                border: true
                                                              }
                                                            },
                                                            [_vm._v("Não")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "help erro"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3782453518
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("app-buttons-cadastro", {
                    staticClass: "buttonValidarProcesso",
                    attrs: {
                      isUltimoPasso: _vm.isUltimoPasso,
                      isPrimeiroPasso: !_vm.isUltimoPasso,
                      showButtonSalvar: _vm.showSalvar,
                      showButtonProximo: _vm.showButtonProximo,
                      showButtonAnaliseManual: _vm.mudarParaAnaliseAutomatizada,
                      labelButtonAnaliseManual: "Análise automatizada"
                    },
                    on: {
                      finalizar: _vm.finalizar,
                      cancelar: _vm.cancelar,
                      proximo: _vm.proximo,
                      salvar: _vm.salvar,
                      changeAnalise: _vm.changeAnalise,
                      voltar: _vm.voltar
                    }
                  })
                ],
                1
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f15529d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f15529d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/AnalisarValidarProcesso.vue
// module id = null
// module chunks = 